// 60fps === 66ms per frame

export const scrollInterval = 66;
// Start loading additional code/assets X screens before it's in view

export const numScreensLazyLoad = 2;
